import { useBlocker } from "react-router-dom"

export const Prompt = props => {
  useBlocker(() => {
    return !window.confirm(props.message)
  })
}

export default Prompt
